import { HttpClient } from '@angular/common/http';
import { inject, Injectable } from '@angular/core';
import { Response } from '@shared/models/response.model';
import { Message } from './model/message.model';
import { MessageCreateRequest } from './request/create-request';
import { MessageUpdateRequest } from './request/update-request';

@Injectable({
  providedIn: 'root',
})
export class MessagesInformationService {
  #http = inject(HttpClient);

  readonly BASE_URL = '/messages-information';

  trouverTous = (actifs: boolean) => this.#http.get<Response<Message>>(this.BASE_URL, { params: { actifs } });

  modifier = (id: string, message: MessageUpdateRequest) => this.#http.put<Message>(this.BASE_URL + '/' + id, message);

  créer = (request: MessageCreateRequest) => this.#http.post<Message>(this.BASE_URL, request);

  supprimer = (id: string) => this.#http.delete<void>(this.BASE_URL + '/' + id);
}
